import Vue from 'vue'

import './styles/quasar.sass'
import 'quasar/dist/quasar.ie.polyfills'
import '@quasar/extras/material-icons/material-icons.css'
import { QBtn, QIcon, Quasar, Notify, QMenu, ClosePopup, QHeader, Loading ,Cookies } from 'quasar'

Vue.use(Quasar, {
    config: {},
    components: { QMenu, QHeader },
    directives: { ClosePopup },
    plugins: {
        Notify,
        QBtn,
        QIcon,
        Loading,
        Cookies
    }
})